<div class="parent-container">
    <app-editable-text [customClass]="'header-custom-class-text'" [elemId]="subtitleId()">
    </app-editable-text>

    <app-editable-text [customClass]="'header-custom-class-text'" [elemId]="titleId()">
    </app-editable-text>

</div>